import React from 'react';
import { createPortal } from 'react-dom';

const NotificationPromptModal = ({ onAccept, onLater, isDenied, darkMode }) => {
  return createPortal(
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60">
      <div className={`p-6 rounded-xl shadow-xl max-w-md w-full mx-4 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-black'}`}>
        <h2 className="text-xl font-semibold mb-4">Notificaciones necesarias</h2>

        {isDenied ? (
          <>
            <p className="mb-4 text-sm leading-relaxed">
              Tienes las notificaciones bloqueadas en este navegador.
            </p>
            <p className="mb-6 text-sm leading-relaxed">
              Para recibir mensajes, regalos y solicitudes en tiempo real, debes
              habilitarlas desde la configuración de tu navegador.
            </p>
            <button onClick={onLater} className="w-full px-4 py-2.5 bg-rose-500 text-white rounded-full font-semibold hover:bg-rose-600">
              Entendido
            </button>
          </>
        ) : (
          <>
            <p className="mb-4 text-sm leading-relaxed">
              En Yourpack, las notificaciones son esenciales para que puedas recibir al instante:
            </p>
            <ul className="mb-4 text-sm space-y-2 list-disc pl-5">
              <li> Mensajes de tus seguidores</li>
              <li> Regalos y coins recibidos</li>
              <li> Solicitudes de live streaming</li>
              <li> Nuevos pedidos y ventas</li>
            </ul>
            <p className="mb-6 text-sm">
              Sin notificaciones no podrás enterarte de lo que sucede en tu cuenta en tiempo real.
            </p>
            <div className="flex gap-3">
              <button onClick={onAccept} className="flex-1 px-4 py-2.5 bg-rose-500 text-white rounded-full font-semibold hover:bg-rose-600">
                Aceptar notificaciones
              </button>
              <button onClick={onLater} className={`px-4 py-2.5 rounded-xl font-semibold ${darkMode ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-black'}`}>
                Más tarde
              </button>
            </div>
          </>
        )}
      </div>
    </div>,
    document.body
  );
};

export default NotificationPromptModal;
